<script setup lang="ts">
import type { Law } from '~/utils/solr/law'

defineProps<{
  groups: { heading: string | null, laws: Law[] }[]
  isLoading: boolean
}>()
</script>

<template>
  <div v-if="isLoading" aria-label="Lover - Laster">
    <div v-for="letter in ['A', 'B', 'C']" :key="letter" class="w-full flex flex-col gap-2xs">
      <LawGroupHeader :letter="letter" :class="{ 'pt-m': letter !== 'A' }" />
      <div class="grid grid-cols-2 gap-2xs w-full">
        <div
          v-for="n in 6"
          :key="n"
          aria-hidden="true"
          class="flex items-center w-full h-[4.625rem] no-underline py-2xs px-xs rounded border-2 border-surface-primary bg-surface-primary"
        >
          <LawItemSkeleton />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="w-full" aria-label="Lover">
    <template v-for="(group, index) in groups" :key="group.heading ?? '__flat__'">
      <LawGroupHeader v-if="group.heading" :letter="group.heading" :class="{ 'pt-m': index !== 0 }" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-2xs w-full">
        <LawItem v-for="law in group.laws" :key="law.id" :law="law" />
      </div>
    </template>
  </div>
</template>